// removed by extract-text-webpack-plugin
module.exports = {"StatisticsResource":"_1ujZM-1RrUsEB2ktkCgKRy","title":"geMzOH84upHj7wMlErYXs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsResource.less
// module id = 1348
// module chunks = 0